import { VideoTestimonialCard } from "@kunduz/ui-components";
import styles from "./videoTestimonialCardV2.module.scss";
import { WistiaPlayer } from "@wistia/wistia-player-react";

export const VideoTestimonialCardV2 = (props: VideoTestimonialCardV2Props) => {
  const { desc, thumbnail, title, videoUrl, wistiaId } = props;

  const renderVideo = () => {
    if (wistiaId) {
      return (
        <WistiaPlayer
          id={`wistia-video-${wistiaId}`}
          mediaId={wistiaId}
          aspect={16 / 9}
          controlsVisibleOnLoad
          volumeControl
          className={styles.video}
          key={wistiaId}
          wistiaPopover
        />
      );
    }

    return (
      <VideoTestimonialCard
        desc={desc}
        thumbnail={thumbnail}
        title={title}
        videoUrl={videoUrl}
        className={styles.videoItem}
      />
    );
  };

  return <div className={styles.container}>{renderVideo()}</div>;
};

export interface VideoTestimonialCardV2Props {
  thumbnail: string;
  title: string;
  desc: string;
  videoUrl?: string;
  wistiaId?: string;
}
